import { LuIcon, Menu, type MenuRootProps, type MenuVariantProps } from "@overmap-ai/blocks"
import type { Form, Stored, User } from "@overmap-ai/common"
import { memo, type ReactElement, useCallback } from "react"

import { CreatedByFilterDef } from "../../filtering/defs/CreatedByFilterDef"
import { SubmittedAtFilterDef } from "../../filtering/defs/SubmittedAtFilterDef"
import { FilterManager } from "../../filtering/manager"
import { modelIconMapping } from "../../mappings/icons"

export interface FormFilterMenuProps extends MenuRootProps, MenuVariantProps {
	children: ReactElement
	filterManager: FilterManager<Stored<Form>>
	users: User[]
}

export const FormFilterMenu = memo<FormFilterMenuProps>((props) => {
	const { children, variant, size, accentColor, filterManager, users, ...rest } = props

	const handleSelectCreatedBy = useCallback(() => {
		filterManager.addFilter(new CreatedByFilterDef(users).createFilter())
	}, [filterManager, users])

	const handleSelectSubmittedAt = useCallback(() => {
		filterManager.addFilter(new SubmittedAtFilterDef().createFilter())
	}, [filterManager])

	return (
		<Menu.Root {...rest}>
			<Menu.ClickTrigger>{children}</Menu.ClickTrigger>
			<Menu.Content variant={variant} size={size} accentColor={accentColor}>
				<Menu.Scroll>
					<Menu.Item onSelect={handleSelectCreatedBy}>
						<LuIcon icon={modelIconMapping.creator} />
						Created by
					</Menu.Item>
					<Menu.Item onSelect={handleSelectSubmittedAt}>
						<LuIcon icon={modelIconMapping.dueDate} />
						Submitted at
					</Menu.Item>
				</Menu.Scroll>
			</Menu.Content>
		</Menu.Root>
	)
})
FormFilterMenu.displayName = "FormFilterMenu"
